// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import SheetController from "./sheet_controller"
application.register("sheet", SheetController)

import FastingTimerController from "./fasting_timer_controller"
application.register("fasting-timer", FastingTimerController)

import MedicalLightboxController from "./medical_lightbox_controller"
application.register("medical-lightbox", MedicalLightboxController)

import FileDropController from "./file_drop_controller"
application.register("file-drop", FileDropController)

import FastingTypeController from "./fasting_type_controller"
application.register("fasting-type", FastingTypeController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)
